(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frostsnap-product"]) return;
  try {
    
function initFrostSnap(scope=document){
  scope.querySelectorAll('[data-frostsnap-product]').forEach(root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const form=root.querySelector('.fsp-form');
    const syncStoryPrice=choice=>{
      root.querySelectorAll('[data-fs-content-price]').forEach(node=>{node.textContent=choice.dataset.price});
      root.querySelectorAll('[data-fs-content-compare]').forEach(node=>{node.textContent=choice.dataset.compare;node.hidden=!choice.dataset.compare});
    };
    const variantInput=form.querySelector('[data-fs-variant-id]');
    root.querySelector('.fsp-native-variants').hidden=true;
    root.querySelector('.fsp-variants').hidden=false;
    const initialChoice=form.querySelector('[name="frostsnap_variant"]:checked');
    if(initialChoice)syncStoryPrice(initialChoice);
    const quantity=form.querySelector('[name="quantity"]');
    const updateQuantity=()=>{root.querySelector('[data-fs-sticky-quantity]').textContent=quantity.checkValidity()?quantity.value:'1'};
    quantity.addEventListener('input',updateQuantity);
    quantity.addEventListener('change',updateQuantity);
    const main=root.querySelector('.fsp-image');
    const thumbs=[...root.querySelectorAll('.fsp-thumb')];
    const dialog=root.querySelector('dialog');
    const show=thumb=>{
      if(!thumb)return;
      main.srcset=[360,540,720,960,1200].map(width=>{const url=new URL(thumb.dataset.src,location.href);url.searchParams.set('width',width);return url.href+' '+width+'w'}).join(',');
      main.src=thumb.dataset.src;
      main.alt=thumb.dataset.alt;
      thumbs.forEach(button=>button.setAttribute('aria-pressed',String(button===thumb)));
      root.querySelector('[data-fs-count]').textContent=(thumbs.indexOf(thumb)+1)+' / '+thumbs.length;
      const strip=thumb.parentElement;
      strip.scrollTo({left:thumb.offsetLeft-strip.offsetLeft-(strip.clientWidth-thumb.clientWidth)/2,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    };
    thumbs.forEach(thumb=>thumb.addEventListener('click',()=>show(thumb)));
    const move=direction=>{const current=thumbs.findIndex(thumb=>thumb.getAttribute('aria-pressed')==='true');show(thumbs[(current+direction+thumbs.length)%thumbs.length])};
    root.querySelector('[data-fs-prev]').addEventListener('click',()=>move(-1));
    root.querySelector('[data-fs-zoom]').addEventListener('keydown',event=>{if(event.key!=='ArrowLeft'&&event.key!=='ArrowRight')return;event.preventDefault();move(event.key==='ArrowLeft'?-1:1)});
    root.querySelector('[data-fs-next]').addEventListener('click',()=>move(1));
    root.querySelector('.fsp-thumbnails').addEventListener('keydown',event=>{if(event.key!=='ArrowLeft'&&event.key!=='ArrowRight')return;event.preventDefault();move(event.key==='ArrowLeft'?-1:1);thumbs.find(thumb=>thumb.getAttribute('aria-pressed')==='true').focus({preventScroll:true})});
    root.querySelectorAll('[data-fs-pick]').forEach(link=>link.addEventListener('click',event=>{
      const radio=form.querySelector('[name="frostsnap_variant"][value="'+link.dataset.fsPick+'"]');
      if(!radio||radio.disabled)return;
      event.preventDefault();radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));
      form.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      radio.focus({preventScroll:true});
    }));
    form.addEventListener('change',event=>{
      if(event.target.name!=='frostsnap_variant')return;
      const choice=event.target;
      variantInput.value=choice.value;
      variantInput.dispatchEvent(new Event('change',{bubbles:true}));
      syncStoryPrice(choice);
      root.querySelector('[data-fs-color]').textContent=choice.dataset.title;
      root.querySelector('[data-fs-sticky-color]').textContent=choice.dataset.title;
      root.querySelector('[data-fs-price]').textContent=choice.dataset.price;
      root.querySelector('[data-fs-sticky-price]').textContent=choice.dataset.price;
      const compare=root.querySelector('[data-fs-compare]');
      compare.textContent=choice.dataset.compare;compare.hidden=!choice.dataset.compare;
      const saving=root.querySelector('[data-fs-saving]');
      saving.textContent=choice.dataset.saving;saving.hidden=!choice.dataset.saving;
      show(thumbs.find(thumb=>thumb.dataset.imageId===choice.dataset.imageId));
      const url=new URL(location.href);url.searchParams.set('variant',choice.value);history.replaceState({},'',url);
    });
    root.querySelector('[data-fs-zoom]').addEventListener('click',()=>{
      const large=dialog.querySelector('img');const url=new URL(main.src,location.href);url.searchParams.set('width',1600);large.src=url.href;large.alt=main.alt;dialog.showModal();
    });
    root.querySelector('[data-fs-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});
    const sticky=root.querySelector('[data-fs-sticky]');
    const observer=new IntersectionObserver(entries=>{
      const entry=entries[0];sticky.hidden=entry.isIntersecting;
    },{threshold:0});
    observer.observe(root.querySelector('.fsp-purchase'));
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initFrostSnap());else initFrostSnap();
document.addEventListener('shopify:section:load',event=>initFrostSnap(event.target));

  } catch(e) { console.error(e); }
})();
})();
